import { apiFetch } from 'common/api/utils';
import { E_COMM_BRANDS_URL } from 'common/api/config';
import { Product } from 'common/api/e-comm/models/Product';

export const getReloadProduct = (brandId: number) =>
    apiFetch<Product>(`${E_COMM_BRANDS_URL}/${brandId}/products/reload`);
